import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../../Box'

const Sidebar = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      flexDirection="column"
      width={['100%', '100%', '375px']}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

Sidebar.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

export default Sidebar
